// extracted by mini-css-extract-plugin
module.exports = {"table":"Table_table__3qmb0","thead":"Table_thead__W2OBr","tr":"Table_tr__368c8","th":"Table_th__1l9IP","td":"Table_td__3-11u"};